import {Status} from 'platform/components';
import {VStack, Text, Show} from 'platform/foundation';

import {isNilOrEmpty} from 'ramda-adjunct';

import {InterestActivityResponseBody} from '@dms/api/sales';
import i18n from '@dms/i18n';

import {ActivityItem} from './ActivityItem';

interface ActivityListProps {
  label: string;
  items: InterestActivityResponseBody[];
  interestId: string;
  showEmpty?: boolean;
}

export function ActivityList(props: ActivityListProps) {
  return (
    <VStack spacing={4} height="auto">
      <Text size="xSmall" color="secondary">
        {props.label}
      </Text>

      <Show when={props.showEmpty && isNilOrEmpty(props.items)}>
        <Status headline={i18n.t('entity.activityPanel.activity.noNextSteps')} />
      </Show>

      <VStack spacing={0}>
        <Show when={props.items.length}>
          {props.items.map((item, index) => (
            <ActivityItem
              key={item.id}
              item={item}
              showLineToNextItem={index === props.items.length - 1}
              interestId={props.interestId}
            />
          ))}
        </Show>
      </VStack>
    </VStack>
  );
}
